import React, {useState} from "react" ;
import {Route, Switch} from "react-router-dom";

import AppSidebarMenuItem from "../../Common/Sidebar/AppSidebarMenuItem";
import AppSidebarGroup from "../../Common/Sidebar/AppSidebarGroup";

import PostsSubmenu from "./PostsSubmenu";
import {
    PATH_POSTS_ROOT,
    getPostRouterLink, PATH_POSTS_POSTS
} from "root/Wieldy/routePaths";
import ScrollRails from "root/Wieldy/ApplicationModules/Common/Body/ScrollRails";
import AppSidebarHeader from "root/Wieldy/ApplicationModules/Common/Sidebar/AppSidebarHeader";

const PostsAppSidebar= (props) =>
{
    return (
        <div className="dt-module__sidebar">

            <AppSidebarHeader iconName={props.iconName} title={props.title} />

            <div className="dt-module__sidebar-content ps-custom-scrollbar ps" style={{height: props.height}}>

                <ul className="dt-module-side-nav">

                    <AppSidebarGroup title='View' default='posts'>
                        <AppSidebarMenuItem link={getPostRouterLink('posts?type=pending')} title='My Posts' iconName='icon-camera' name='posts' />
                    </AppSidebarGroup>

                    <Switch>
                        <Route path={PATH_POSTS_POSTS} render={(thisprops) => <PostsSubmenu {...thisprops}/>}/>
                        <Route exact path={PATH_POSTS_ROOT} render={(thisprops) => <PostsSubmenu {...thisprops}/>}/>
                    </Switch>

                </ul>

                <ScrollRails />

            </div>

        </div>
    ) ;
}

export default PostsAppSidebar;
